import { type HomeProjectAttachment } from "@repo/api";

import { type FileLoadingEnum, getFileType } from "../utils";
import { FileListItem } from "./FileListItem";

export const HomeProjectFileItem = ({
  file,
  loading,
  loadingFileId,
  editable,
  onDownload,
}: {
  file: HomeProjectAttachment;
  loading?: FileLoadingEnum;
  loadingFileId?: number;
  editable?: boolean;
  onDownload: (
    name: string,
    attachmentId: number,
    action: "OPEN" | "DOWNLOAD",
    mimeType: string,
    url?: string
  ) => void;
}) => {
  return (
    <FileListItem
      attachmentId={file.attachmentId}
      fileName={file.fileName}
      fileType={getFileType(file.fileName)}
      uploadedDate={file.updatedDate}
      allowPreview={Boolean(file.url)}
      onDownload={(action) =>
        onDownload(
          file.fileName,
          file.attachmentId,
          action,
          getFileType(file.fileName) ?? "application/octet-stream",
          file.url
        )
      }
      editable={editable}
      loading={loading}
      loadingFileId={loadingFileId}
    />
  );
};
